import Vue from 'vue'

// axios
import axios from 'axios'

const licenceKey = localStorage.getItem('licenceKey')
const branchData = JSON.parse(localStorage.getItem('branchData'))
let branchId = null
if (branchData) {
  branchId = branchData.id
}
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: 'https://dr-api.zennosys.com/',
  // timeout: 1000,
  headers: {
    LicenceKey: licenceKey,
    BranchCode: branchId,
  },
})

Vue.prototype.$http = axiosIns

export default axiosIns
